var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/EstimationPreview/mockPropsNodeContainer.ts";
import { createStore } from 'effector'; //TODO: make this props optional in NodeContainer

export var mockPropsNodeContainer = {
  // eslint-disable-next-line no-empty-function
  onLoadMore: function onLoadMore() {},
  // eslint-disable-next-line no-empty-function
  onChecked: function onChecked() {},
  dynamicMode: false,
  // eslint-disable-next-line no-empty-function
  onSubmitEditing: function onSubmitEditing() {},
  searchNodes: null,
  onPending: function onPending() {
    return false;
  },
  isSpecialNode: false,
  highlightItem: null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependenciesWithModels$: createStore([], {
    name: "dependenciesWithModels$",
    sid: "1v2egl"
  }),
  searchMatched$: createStore({}, {
    name: "searchMatched$",
    sid: "6w1llb"
  }),
  checkbox: {
    checked: false
  },
  // eslint-disable-next-line no-empty-function
  onDroppedToGroup: function onDroppedToGroup() {},
  canDropToGroup: function canDropToGroup() {
    return false;
  },
  // eslint-disable-next-line no-empty-function
  onDroppedBefore: function onDroppedBefore() {},
  // eslint-disable-next-line no-empty-function
  onDroppedAfter: function onDroppedAfter() {},
  canDropBefore: function canDropBefore() {
    return false;
  },
  canDropAfter: function canDropAfter() {
    return false;
  },
  // eslint-disable-next-line no-empty-function
  onSubmitCreating: function onSubmitCreating() {},
  // eslint-disable-next-line no-empty-function
  onCancelCreating: function onCancelCreating() {},
  // eslint-disable-next-line no-empty-function
  onCancelEditing: function onCancelEditing() {},
  inEdit: false
};